import '../assets/NcHotkeyList-gAZN0WIu.css';
import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, toDisplayString, unref, renderSlot } from "vue";
import { r as register, a as t } from "./_l10n-DrTiip5c.mjs";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
register();
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcHotkeyList",
  props: {
    label: { default: () => void 0 }
  },
  setup(__props) {
    const labelId = `NcHotkeyList_${createElementId()}`;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(_ctx.$style.hotkeyList)
      }, [
        createElementVNode("div", {
          id: labelId,
          class: normalizeClass([_ctx.$style.hotkeyList__heading, { "hidden-visually": !_ctx.label }])
        }, toDisplayString(_ctx.label || unref(t)("Keyboard shortcuts")), 3),
        createElementVNode("ul", { "aria-labelledby": labelId }, [
          renderSlot(_ctx.$slots, "default")
        ])
      ], 2);
    };
  }
});
const hotkeyList = "_hotkeyList_pf97p_2";
const hotkeyList__heading = "_hotkeyList__heading_pf97p_6";
const style0 = {
  hotkeyList,
  hotkeyList__heading
};
const cssModules = {
  "$style": style0
};
const NcHotkeyList = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcHotkeyList as N
};
//# sourceMappingURL=NcHotkeyList-BBE5BqwB.mjs.map
